import pino from 'pino';

export const logger = pino({
  name: 'swoft',
  level: 'info',
  transport: {
    target: 'pino-pretty',
    options: {
      colorize: true,
      ignore: 'pid,hostname',
    },
  },
});